webpackJsonp([83],{

/***/ 1086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__ = __webpack_require__(170);


$(function () {

    var shareButtonsClass = "share-buttons";

    __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__["a" /* default */].init(shareButtonsClass);
    __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__["a" /* default */].initScroll(shareButtonsClass);
    window.pym.autoInit();

    // Editor cm link hack
    var cmLink = $("#article-content").data('cm');
    if (cmLink) {
        $(document).on('dblclick', '#article-title', function (e) {
            if (e.shiftKey && e.altKey) {
                var win = window.open(cmLink, '_blank');
                win.focus();
            }
        });
    }

    if ($(document).find('.date__container__left').length > 0) {
        var dateContainerWidth = $(".date__container").width();
        var dateItem = $(".date__item").width();
        var nbItems = $(".date__item").length;
        var itemsWidth = nbItems * dateItem;

        if (itemsWidth > dateContainerWidth) {
            $(".date__container__displayer").removeClass("hide");
        }
    }
});

/***/ })

},[1086]);


// WEBPACK FOOTER //
// javascripts/mywortArticlePage.js